import { render, staticRenderFns } from "./psychology.vue?vue&type=template&id=fbe4b4f4&scoped=true"
import script from "./psychology.vue?vue&type=script&lang=js"
export * from "./psychology.vue?vue&type=script&lang=js"
import style0 from "./psychology.vue?vue&type=style&index=0&id=fbe4b4f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe4b4f4",
  null
  
)

export default component.exports